import { render, staticRenderFns } from "./Wages.vue?vue&type=template&id=0a6043a4&scoped=true"
import script from "./Wages.vue?vue&type=script&lang=js"
export * from "./Wages.vue?vue&type=script&lang=js"
import style0 from "./Wages.vue?vue&type=style&index=0&id=0a6043a4&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6043a4",
  null
  
)

export default component.exports